module.exports = __webpack_public_path__ + "img/register_after.d43ef700.png";